import { Attributes, NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class FileExportStatusDTO extends ValueObject {
    
    @Attributes.Date()
    public exportDate: Date | null = null;

    public fileName: string = "";

    public exportTime: string = "";
}